import React from 'react';
import CompanySearch from '../features/company-search';

/**
 * Page component for the Company Search feature
 */
const CompanySearchPage: React.FC = () => {
  return (
    <div>
      <CompanySearch />
    </div>
  );
};

export default CompanySearchPage;
